import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ColumnLayoutItem,
  TwoColumnLayoutWrapper,
} from "../../common/Common.style";
import { FilterDataType, USER_TYPE } from "@home-health-notify/domain";
import { USER_TYPE_TEXT, useTranslation } from "hhn-commons";

type UserTypeFiltersProps = {
  filteredUserTypes: USER_TYPE[];
  filterData: FilterDataType;
  onUserTypeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLabelClick: (
    value: string | USER_TYPE,
    filterDataKey: keyof FilterDataType,
  ) => void;
};

const UserTypeFilters = ({
  filteredUserTypes,
  filterData,
  onUserTypeChange,
  onLabelClick,
}: UserTypeFiltersProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userDirectory" });

  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="accordion-content"
      >
        <Typography>{tNs("filter.userType")}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <TwoColumnLayoutWrapper data-testid="user-type-checkbox-container">
          {filteredUserTypes.map((key: USER_TYPE) => {
            const userTypeText =
              USER_TYPE_TEXT[key as keyof typeof USER_TYPE_TEXT];
            return (
              <ColumnLayoutItem key={key}>
                <Checkbox
                  value={key}
                  checked={filterData.userType.includes(key)}
                  onChange={onUserTypeChange}
                />
                <Typography
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => onLabelClick(key, "userType")}
                >
                  {userTypeText}
                </Typography>
              </ColumnLayoutItem>
            );
          })}
        </TwoColumnLayoutWrapper>
      </AccordionDetails>
    </Accordion>
  );
};

export default UserTypeFilters;
